import FNSSub from 'date-fns/sub'
import FNSAdd from 'date-fns/add'
import FNSFormat from 'date-fns/format'
import FNSParse from 'date-fns/parse'
import FNSGetMonth from 'date-fns/getMonth'
import FNSDifferenceInDays from 'date-fns/differenceInDays'

const dateFormat = 'dd/MM/yyyy'
const _DIVIDERSYMBOL = '/'

/**
 * Cambiar fecha por suma.
 *
 * @param {Date} inputDate Fecha a modificar.
 * @param {{
 *    years?: number
 *    months?: number
 *    days?: number
 *    hours?: number
 *    minutes?: number
 *    seconds?: number
 * }} addInfo Parametros de suma.
 * @returns {Date} Fecha nueva.
 */
const add = (inputDate, addInfo) => {
  const nuevaFecha = FNSAdd(inputDate, addInfo)
  return nuevaFecha
}

/**
 * Obtener diferencia de dias.
 *
 * @param {Date} inputDate Fecha fin.
 * @param {Date} secondDate Fecha inicio.
 * @returns {number} Diferencia de dias.
 */
const differenceInDays = (inputDate, secondDate) => {
  const diferencia = FNSDifferenceInDays(inputDate, secondDate)
  return diferencia
}

/**
 * Dar formato a fecha.
 *
 * @param {Date} inputDate Fecha a modificar.
 * @returns {string} Fecha nueva.
 */
const format = inputDate => {
  const fechaString = FNSFormat(inputDate, dateFormat)
  return fechaString
}

/**
 * Dar formato a fecha.
 *
 * @param {Date} inputDate Fecha a modificar.
 * @returns {number} Fecha nueva.
 */
const getMonth = inputDate => {
  const monthNumber = FNSGetMonth(inputDate)
  return monthNumber
}

/**
 * String valido.
 *
 * @param {string} inputString String a convertir.
 * @returns {boolean} string valido.
 */
const isValidString = inputString => {
  return /^(?:(?:31(\/)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(
    inputString
  )
}

/**
 * Convertir string a fecha.
 *
 * @param {string} inputString String a convertir.
 * @returns {Date} Fecha nueva.
 */
const parse = inputString => {
  const parsedDate = FNSParse(inputString, dateFormat, new Date())
  return parsedDate
}

/**
 * Cambiar fecha por resta.
 *
 * @param {Date} inputDate Fecha a modificar.
 * @param {{
 * years?: number
 * months?: number
 * days?: number
 * hours?: number
 * minutes?: number
 * seconds?: number
 * }} substractInfo Parametros de resta.
 * @returns {Date} Fecha nueva.
 */
const substract = (inputDate, substractInfo) => {
  const nuevaFecha = FNSSub(inputDate, substractInfo)
  return nuevaFecha
}

export default Object.freeze({
  _DIVIDERSYMBOL,
  add,
  differenceInDays,
  format,
  getMonth,
  isValidString,
  parse,
  substract
})
